import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type {
  exportTableColumnValidation,
  tableColumnValidation,
  TableSettingColumn,
} from 'types/tableSettingsTypes';

interface AdminCategoriesState {
  filterData: Record<string, any>;
  reloadTableData: boolean;
  tableColumnValidation: tableColumnValidation;
  defaultColumnList: TableSettingColumn[];
  tableColumnList: TableSettingColumn[];
  exportTableColumnValidation: exportTableColumnValidation;
  exportTableColumnList: TableSettingColumn[];
}
const defaultColumnList = [
  {
    name: 'name',
    label_key: 'category',
    allow_list: true,
    allow_filter: false,
    show_list_checkbox: true,
    show_filter_checkbox: false,
    order: 1,
  },
  // {
  //   name: 'parent_category',
  //   label_key: 'parent_category',
  //   allow_list: true,
  //   allow_filter: true,
  //   show_list_checkbox: true,
  //   show_filter_checkbox: true,
  //   order: 2,
  // },
  {
    name: 'total_product',
    label_key: 'x_of_products',
    allow_list: true,
    allow_filter: false,
    show_list_checkbox: true,
    show_filter_checkbox: false,
    order: 3,
  },
  {
    name: 'total_ffl',
    label_key: 'x_of_ffl',
    allow_list: true,
    allow_filter: false,
    show_list_checkbox: true,
    show_filter_checkbox: false,
    order: 4,
  },
  {
    name: 'sub_category',
    label_key: 'sub_category',
    allow_list: true,
    allow_filter: false,
    show_list_checkbox: true,
    show_filter_checkbox: false,
    order: 7,
  },
  {
    name: 'created_at',
    label_key: 'created_at',
    allow_list: true,
    allow_filter: false,
    show_list_checkbox: true,
    show_filter_checkbox: false,
    order: 8,
  },
  {
    name: 'status',
    label_key: 'status',
    allow_list: true,
    allow_filter: true,
    show_list_checkbox: true,
    show_filter_checkbox: true,
    type: 'select',
    filter_placeholder: 'status_all',
    selectKey: 'status',
    option_value_key: 'id',
    option_label_key: 'name',
    multi: false,
    order: 9,
  },

  {
    name: 'is_featured',
    label_key: 'is_featured',
    allow_list: true,
    allow_filter: true,
    show_list_checkbox: true,
    show_filter_checkbox: true,
    type: 'select',
    filter_placeholder: 'featured_all',
    selectKey: 'featured',
    option_value_key: 'id',
    option_label_key: 'name',
    multi: false,
    order: 2,
  },
];
const mappedList = defaultColumnList.map((list) => ({
  ...list,
  allow_list: true,
  show_list_checkbox: true,
}));
const exportColumnList = [
  ...mappedList.slice(0, 4),
  {
    name: 'parent_category',
    label_key: 'parent_category',
    allow_list: true,
    allow_filter: false,
    show_list_checkbox: true,
    show_filter_checkbox: false,
    order: 5,
  },
  ...mappedList.slice(4),
];
const initialState: AdminCategoriesState = {
  filterData: {},
  reloadTableData: false,
  tableColumnValidation: {
    minListColumn: 2,
    maxListColumn: 8,
    minFilterColumn: 0,
    maxFilterColumn: 8,
  },
  defaultColumnList: defaultColumnList,
  tableColumnList: JSON.parse(JSON.stringify(defaultColumnList)),
  exportTableColumnValidation: {
    minListColumn: 2,
  },
  exportTableColumnList: exportColumnList,
};

const adminCategoriesSlice = createSlice({
  name: 'adminCategories',
  initialState,
  reducers: {
    setFilterData(state, action: PayloadAction<Record<string, any>>) {
      state.filterData = { ...state.filterData, ...action.payload };
    },
    resetFilterData(state) {
      state.filterData = {};
    },
    setReloadTableData(state, action: PayloadAction<boolean>) {
      state.reloadTableData = action.payload;
    },
    setCategoryTableColumnList(state, action: PayloadAction<TableSettingColumn[]>) {
      state.tableColumnList = action.payload;
    },
  },
});

export const { setFilterData, resetFilterData, setReloadTableData, setCategoryTableColumnList } =
  adminCategoriesSlice.actions;

export default adminCategoriesSlice.reducer;
